var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareDarkTransparent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "11 84 99 54",
    enableBackground: "new 0 0 216 216",
    space: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    d: "M16.439,129.258H13.5v-33.8 c0,0,11.757-5.458,47.027-5.458c35.27,0,47.026,5.458,47.026,5.458v33.8h-2.939"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#CC6633",
    strokeWidth: 4,
    strokeLinecap: "round",
    points: "56.118,104.275  23.787,104.275 23.787,129.258 56.118,129.258  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#CC6633",
    strokeWidth: 4,
    strokeLinecap: "round",
    points: "97.267,104.275 64.936,104.275  64.936,129.258 97.267,129.258 97.267,118.971 85.51,118.971  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareDarkTransparent);
export default __webpack_public_path__ + "static/media/squareDarkTransparent.dde4f5664b8c5f45c6da06841aa76096.svg";
export { ForwardRef as ReactComponent };